import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "fileInput"]

  connect() {
    this.files = []
  }

  handleFileSelect(event) {
    const selectedFiles = Array.from(event.target.files)
    this.files = [...this.files, ...selectedFiles]
    this.renderPreview()
  }

  removeFile(event) {
    const index = parseInt(event.currentTarget.dataset.index)
    this.files.splice(index, 1)
    this.renderPreview()
  }

  renderPreview() {
    this.previewTarget.innerHTML = ""

    this.files.forEach((file, index) => {
      const fileElement = this.createFileElement(file, index)
      this.previewTarget.appendChild(fileElement)
    })

    this.previewTarget.classList.toggle('hidden', this.files.length === 0)
  }

  createFileElement(file, index) {
    const div = document.createElement('div')
    div.className = 'file-preview-item'
    div.innerHTML = `
      <span class="file-name">${file.name}</span>
      <span class="file-size">(${this.formatFileSize(file.size)})</span>
      <button type="button" class="circular ui icon button" data-action="file-upload#removeFile" data-index="${index}">
        <i class="icon trash"></i>
      </button>
    `
    return div
  }

  formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
  }

  getFormData() {
    const formData = new FormData()
    this.files.forEach(file => {
      formData.append('files[]', file)
    })
    return formData
  }
}
